import { URL_FILES } from './envs'

export const FIDELITY_BANNER_DESKTOP = `${URL_FILES}fidelity/BANNER_FIDELITY_DESKTOP.png`
